import {createStack} from '@famly/mf_layout_stack';

/** Simple wrapper for the dialog's top elements */
export const DialogHeader = createStack({flexDirection: 'row'});
